module.exports = __webpack_public_path__ + "static/media/lilienstein_1k.983916e5.hdr";